<form method="dialog" *ngIf="dialog">
    <button class="btn-close float-end"></button>
</form>

<div id="generate-course" class="m-3">

    <h3 class="mb-3">Generar curso</h3>

    <form [formGroup]="courseFormGroup" (ngSubmit)="generateCourse()" id="generate-course-form" class="mb-3">
        <label class="d-block mb-3">
            <p class="fw-bold">Nombre:</p>
            <input type="text" class="form-control" formControlName="name">
        </label>
    
        <div class="d-block mb-3">
            <label class="w-25 d-inline-block me-3 mb-3">
                <p class="fw-bold">Número de horas:</p>
                <input type="number" class="form-control" min="1" formControlName="hours">
            </label>
    
            <label class="w-25 d-inline-block me-3 mb-3">
                <p class="fw-bold">Número de unidades:</p>
                <input type="number" class="form-control" min="1" formControlName="unitsNum">
            </label>
        </div>

        <div>
            <p class="fw-bold">Categoría: {{ category.name }}</p>
        </div>

        <hr>

        <div formArrayName="units" class="mb-3 border-0">
            <details *ngFor="let unit of units.controls; let u = index">
                <summary class="fw-bold">
                    <span>Unidad {{ u + 1 }}</span>
                    <span class="text-success ms-3" *ngIf="unit.valid"><i class="fas fa-check"></i></span>
                    <span class="text-danger ms-3" *ngIf="unit.invalid"><i class="fas fa-times"></i></span>
                </summary>
                <generate-unit [unitForm]="unit" [unitIndex]="u" [unitName]="'Unidad de aprendizaje ' + (u + 1)"></generate-unit>
            </details>
        </div>

        <div id="generate-course-form-errors" class="alert alert-danger mb-3" *ngIf="courseFormError">
            <div>
                <i class="fas fa-times"></i>
                <span>Errores:</span>
            </div>
            <ul class="my-0">
                <li *ngFor="let error of courseFormErrors">
                    {{ error }}
                </li> 
            </ul>
        </div>

        <div id="generate-course-status">
            <div id="generate-course-running" *ngIf="state == 'running'">
                <p><i class="fas fa-spinner fa-spin me-3"></i>{{ message }}</p>
                <p>Progreso: {{ progress }}%</p>
            </div>
            <div id="generate-course-completed" class="text-success" *ngIf="state == 'completed'">
                <i class="fas fa-check"></i>
                <span>¡Curso generado correctamente!</span>
                <p>Tiempo transcurrido: {{ durationStr }}</p>
            </div>
            <div id="generate-course-failed" class="text-danger" *ngIf="state == 'failed'">
                <i class="fas fa-times"></i>
                <span>Ha habido un problema al generar el curso.</span>
                <p>Tiempo transcurrido: {{ durationStr }}</p>
            </div> 
        </div>


        <div id="generate-course-buttons" class="mb-3">
            <form method="dialog" class="d-inline-block" *ngIf="dialog">
                <button class="btn btn-danger me-3">
                    <i class="fas fa-times"></i>
                    <span>Cerrar</span>
                </button>
            </form>
            <button type="submit" class="btn btn-success me-3" *ngIf="state == 'pending' || state == 'failed'">
                <i class="fas fa-check"></i>
                <span>Generar</span>
            </button>
        </div>
    </form>

</div>